import { render, staticRenderFns } from "./CourseFormDialog.vue?vue&type=template&id=e3da5c74&scoped=true"
import script from "./CourseFormDialog.vue?vue&type=script&lang=js"
export * from "./CourseFormDialog.vue?vue&type=script&lang=js"
import style0 from "./CourseFormDialog.vue?vue&type=style&index=0&id=e3da5c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3da5c74",
  null
  
)

export default component.exports